import api from './api';
import { IMerFot } from '../types/MerFot';

// Fotos do produto (merfot). O upload passa pela API, que envia ao ImageShack e grava o link.

export async function listarFotos(codmer: number | string): Promise<IMerFot[]> {
  const response = await api.get('/merfot', {
    params: { codmer, per_page: 50, order: 'cod' }
  });
  // Com total=0 a API devolve {} (sem data)
  return response.data?.data || [];
}

export async function enviarFoto(codmer: number | string, codbar: string | undefined, codpad: string | undefined, arquivo: Blob, nome: string) {
  const formData = new FormData();
  formData.append('codmer', String(codmer));
  if (codbar) formData.append('codbar', String(codbar));
  if (codpad) formData.append('codpad', String(codpad));
  formData.append('arquivo', arquivo, nome);

  // Sem Content-Type: o navegador monta o multipart com o boundary
  const response = await api.post('/merfot', formData);
  return response.data as IMerFot;
}

export async function excluirFoto(cod: number | string) {
  await api.delete(`/DeleteMerFot/${cod}`);
}

export async function definirCapa(cod: number | string) {
  await api.put(`/fotoCapa/${cod}`);
}

// linfot vem sem protocolo (imagizer.imageshack.com/...)
export function urlFoto(linfot: string) {
  const link = (linfot || '').trim();
  if (!link) return '';
  return /^https?:\/\//i.test(link) ? link : `https://${link}`;
}

export const ehCapa = (foto: IMerFot) => Number(foto.fotcap) === 1;
